const storiesData = {
  'eon-zukunftsindex-2023-pressemeldung': {
    headline: 'E.ON Zukunftsindex 2023 - Pressemeldung',
    description: 'Wie sieht der Status Quo der Energiewende aus? Welche kurzfristigen Pläne haben die Verbraucher - und wie groß sind die maximal möglichen CO₂-Einsparungen? Alle Details zum Zukunftsindex.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2023/2023-07-28-178-millionen-co2-jaehrlich-in-haushalt-und-verkehr.html',
    linkLabel: 'Zur Meldung'
  },
  'flexibilitaets-check-pressemeldung': {
    headline: 'Flexibilitäts-Check - Pressemeldung',
    description: 'Welche Energiemengen lassen sich in deutschen Haushalten aktuell und im Jahr 2031 potenziell verschieben? Der Überblick zum Flexibilitäts-Potenzial.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2026/2026-09-08-eon-flexibilitaets-check-18-3-twh-strom-flexibel-verschiebbar-bis-zu-1-65-milliarden-euro-einsparpotenzial.html',
    linkLabel: 'Zur Meldung'
  },
  'e-mobilitaetsatlas-2024-pressemeldung': {
    headline: 'E-Mobilitätsatlas 2024 - Pressemeldung',
    description: 'Bayern bei Ladepunkten bundesweit vorn, NRW bei E-Auto-Zulassungen - alle Details zum E-Mobility-Atlas 2024.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2024/2024-04-16-nordfriesland-bis-oberallgaeu-eon-energieatlas-zeigt-stetiges-wachstum-bei-ladestationen-und-e-autos-in-deutschlands-landkreisen-und-staedten.html',
    linkLabel: 'Zur Meldung'
  },
  'e-mobilitaetsatlas-2023-pressemeldung': {
    headline: 'E-Mobilitätsatlas 2023 - Pressemeldung',
    description: 'Mit mehr als 1,3 Millionen E- Autos schreitet die E-Mobilität in Deutschland voran. Die größte CO2-Einsparung gibt es in NRW, Bayern hat die höchste Ladeleistung installiert.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2023/2023-12-08-eon-energieatlas-zu-e-mobilitaet-am-meisten-co2-einsparung-in-nrw-bayern-hat-die-hoechste-ladeleistung-installiert.html',
    linkLabel: 'Zur Meldung'
  },
  'e-mobilitaetsatlas-2022-pressemeldung': {
    headline: 'E-Mobilitätsatlas 2022 - Pressemeldung',
    description: 'Die Zahl der E-Autos hat sich binnen eines Jahres auf mehr als 618.000 verdoppelt. Bayern liegt bei Ladepunkten vorn, NRW bei E-Auto-Zulassungen.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2022/2022-07-01-eon-energieatlas-zu-e-mobility-bayern-bei-ladepunkten-bundesweit-vorn.html',
    linkLabel: 'Zur Meldung'
  },
  'e-mobilitaetsatlas-2021-pressemeldung': {
    headline: 'E-Mobilitätsatlas 2021 - Pressemeldung',
    description: 'E-Autos erleben einen Boom - mit einer Steigerung um 126 Prozent im Vergleich zum Vorjahr. Mehr als 309.000 Elektroautos kommen auf über 52.000 öffentliche Ladepunkte.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2021/2021-05-26-eon-energieatlas-zeigt-e-auto-boom.html',
    linkLabel: 'Zur Meldung'
  },
  'infoguide-zu-oekostrom': {
    headline: 'Infoguide zu Ökostrom',
    description: 'Was ist Ökostrom überhaupt und wie kommt der in meine Steckdose? Hier geht\'s zu den Antworten auf diese Fragen und weitere nützliche Informationen zu Ökostrom.',
    link: 'https://www.eon.de/de/pk/strom/stromanbieter/oeko-stromanbieter.html#hintergrund',
    linkLabel: 'Zur Story'
  },
  'elektromobilitaet-autos-unter-strom': {
    headline: 'Elektromobilität - Autos unter Strom',
    description: 'Leben E-Auto-Fans nachhaltiger? Und wie hat sich der Ausbau der Ladestationen entwickelt? Deutschlands E-Mobilität im Überblick. ',
    link: 'https://www.eon.de/de/eonerleben/elektromobilitaet-anzahl-der-ladestationen-fuer-elektroautos-deutlich-gestiegen.html',
    linkLabel: 'Zur Story'
  },
  'e-auto-zuhause-laden': {
    headline: 'E-Auto zuhause laden',
    description: 'Per Wallbox lassen sich Elektroautos schnell in der eigenen Garage mit Strom versorgen. Die Vorteile.',
    link: 'https://www.eon.de/de/pk/e-mobility/zuhause.html',
    linkLabel: 'Zur Story'
  },
  'so-streamt-deutschland': {
    headline: 'So streamt Deutschland',
    description: 'Wer nutzt mindestens einmal wöchentlich Streaming-Angebote - und wo spielt Nachhaltigkeit dabei eine große Rolle? Der Überblick.',
    link: 'https://www.eon.de/de/pk/strom/strom-sparen/streaming-vergleich.html',
    linkLabel: 'Zur Story'
  },
  'stromspar-tipps-fuer-den-haushalt': {
    headline: 'Stromspar-Tipps für den Haushalt',
    description: 'Wie lässt sich in Eigenheim und Wohnung Energie einsparen? Die besten Tipps im Überblick.',
    link: 'https://www.eon.de/de/pk/strom/strom-sparen.html',
    linkLabel: 'Zur Story'
  },
  'so-viel-strom-verbraucht-stand-by': {
    headline: 'So viel Strom verbraucht Stand-by',
    description: 'Fernseher, Ladegeräte, Musikanlage - viel Strom wird unnötig verbraucht. Wie sich das vermeiden lässt.',
    link: 'https://www.eon.de/de/pk/strom/stromverbrauch.html',
    linkLabel: 'Zur Story'
  },
  'e-bikes-auf-dem-vormarsch': {
    headline: 'E-Bikes auf dem Vormarsch',
    description: 'Pedelecs und Elektroräder werden in Deutschland immer beliebter. Was können sie und wie weit radeln die Deutschen damit?',
    link: 'https://www.eon.de/de/eonerleben/energieatlas/e-bikes-auf-dem-vormarsch.html',
    linkLabel: 'Zur Story'
  },
  'e-bikes-auswertung-pressemeldung': {
    headline: 'E-Bikes-Auswertung: Pressemeldung',
    description: 'Wie hat sich die Anzahl der E-Bike-Besitzer zuletzt entwickelt - und welches Flexibilitäts-Potenzial hängt mit E-Rädern zusammen? Der Überblick.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2026/2026-09-01-e-on-umfrage-zeigt-neuen-hoechstwert-fast-jeder-dritte-in-deutschland-faehrt-e-bike.html',
    linkLabel: 'Zur Story'
  },
  'die-mythen-ums-elektroauto': {
    headline: 'Die Mythen ums Elektroauto',
    description: 'Ist das Ladenetz in Deutschland wirklich schlecht? 9 E-Auto-Mythen im Fakten-Check.',
    link: 'https://www.eon.de/de/pk/e-mobility/die-9-groessten-mythen-elektroauto.html',
    linkLabel: 'Zur Story'
  },
  'bidi-potenzial-in-deutschland-pressemeldung': {
    headline: 'Bidi Potenzial in Deutschland - Pressemeldung',
    description: 'Mehr als 225.000 E-Autos sind bereits vorbereitet für bidirektionales Laden. Über Nacht könnten sie 2,5 Mio. Haushalte mit Strom versorgen.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2025/2025-09-08-e-on-analyse-bidirektional-ladende-e-autos-koennten-2-5-millionen-haushalte-von-abends-bis-morgens-mit-strom-versorgen.html',
    linkLabel: 'Zur Meldung'
  },
  'so-funktioniert-bidirektionales-laden': {
    headline: 'So funktioniert bidirektionales Laden',
    description: 'Die Technologie macht das E-Auto zum Stromspeicher. Aus dem Akku kann Strom zurück in den Haushalt oder in das Stromnetz fließen.',
    link: 'https://www.eon.de/de/pk/e-mobility/bidirektionales-laden.html',
    linkLabel: 'Zur Story'
  },
  'e-autofahrer-umfrage': {
    headline: 'E-Autofahrer-Umfrage',
    description: 'Eine E.ON Umfrage zeigt, dass E-Autofahrer großes Interesse an innovativen Ladetarifen haben.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2025/2025-08-08-e-on-e-fahrer-studie-zeigt-interesse-am-bidirektionalen-laden-und-an-innovativen-tarifen.html',
    linkLabel: 'Zur Meldung'
  },
  'e-lkw-a': {
    headline: 'E-Autos und E-Lkw in Deutschland',
    description: 'Bayern bei der Ladeleistung vorne, NRW bei beim E-Fahrzeuge-Bestand. Neuen Meilenstein erreicht: Über 100.000 elektrische Lkw und Transporter sind bereits in Deutschland unterwegs.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2026/2026-02-17-so-viele-e-autos-und-e-lkw-fahren-auf-deutschlands-strassen.html',
    linkLabel: 'Zur Meldung'
  },
  'e-lkw-b': {
    headline: 'Reservierungssystem für Truck Charging',
    description: 'E.ON pilotiert ein neues Reservierungssystem für E-Lkw-Ladestationen. Durch die Plattform können Ladestopps geplant und Ladepunkte im Voraus gebucht werden.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2025/2025-10-01-e-on-entwickelt-innovatives-reservierungssystem-fuer-e-lkw-ladestationen.html',
    linkLabel: 'Zur Meldung'
  },
  'e-lkw-c': {
    headline: 'E-Lkw-Ladestandort bei Salzburg',
    description: 'E.ON und MAN bauen E-Lkw-Schnellladestationen mit 400 kW Leistung in Eugendorf bei Salzburg. Der Standort ist für Megawatt Charging vorbereitet.',
    link: 'https://www.eon.de/de/unternehmen/presse/pressemitteilungen/2025/2025-10-23-spatenstich-fuer-e-lkw-ladestandort-bei-salzburg-eon-und-man-treiben-elektrifizierung-im-schwerlastverkehr-voran.html',
    linkLabel: 'Zur Meldung'
  }
};

const storyMapping = {
  flexCheck: ['flexibilitaets-check-pressemeldung', 'infoguide-zu-oekostrom', 'elektromobilitaet-autos-unter-strom', 'e-auto-zuhause-laden'],
  zukunftsindex: ['eon-zukunftsindex-2023-pressemeldung', 'e-bikes-auf-dem-vormarsch', 'e-mobilitaetsatlas-2024-pressemeldung', 'so-streamt-deutschland', 'elektromobilitaet-autos-unter-strom', 'stromspar-tipps-fuer-den-haushalt', 'die-mythen-ums-elektroauto', 'so-viel-strom-verbraucht-stand-by', 'e-auto-zuhause-laden', 'infoguide-zu-oekostrom'],
  eMobilityVehicles: ['e-lkw-a', 'e-mobilitaetsatlas-2024-pressemeldung', 'e-mobilitaetsatlas-2023-pressemeldung', 'e-mobilitaetsatlas-2022-pressemeldung', 'e-mobilitaetsatlas-2021-pressemeldung', 'elektromobilitaet-autos-unter-strom', 'die-mythen-ums-elektroauto', 'e-auto-zuhause-laden', 'infoguide-zu-oekostrom'],
  eLkw: ['e-lkw-a', 'e-lkw-b', 'e-lkw-c'],
  bidiAtlas: ['bidi-potenzial-in-deutschland-pressemeldung', 'so-funktioniert-bidirektionales-laden', 'e-autofahrer-umfrage', 'flexibilitaets-check-pressemeldung'],
  eBikes: ['e-bikes-auswertung-pressemeldung', 'e-bikes-auf-dem-vormarsch', 'elektromobilitaet-autos-unter-strom', 'die-mythen-ums-elektroauto', 'e-auto-zuhause-laden', 'infoguide-zu-oekostrom']
};

const storyGroups = Object.fromEntries(
  Object.entries(storyMapping).map(([group, ids]) => [group, ids.map((id) => storiesData[id])])
);

module.exports = { storyGroups };
